<script setup lang="ts">
/**
 * Aan/uit-schakelaar met label rechts. Opvolger van Components/Form/Toggle-input.
 *
 * `useId()` i.p.v. `Math.random()`: stabiel tussen renders en SSR-veilig.
 */
import { Switch } from '@headlessui/vue'
import { ref, useId } from 'vue'

const enabled = defineModel<boolean>()

defineProps<{
    /** Vertaalsleutel. */
    label: string
    disabled?: boolean
}>()

const switchId = `switch-${useId()}`

const rootRef = ref<HTMLElement | null>(null)

defineExpose({ focus: () => rootRef.value?.querySelector('button')?.focus() })
</script>

<template>
    <div ref="rootRef" class="flex items-center gap-2 flex-row-reverse justify-between">
        <Switch
            v-model="enabled"
            :id="switchId"
            :disabled="disabled"
            :class="[
                enabled ? 'bg-primary' : 'bg-gray-200',
                { 'cursor-not-allowed opacity-50': disabled },
            ]"
            class="relative inline-flex h-6 w-11 items-center rounded-full"
        >
            <span
                :class="enabled ? 'translate-x-6' : 'translate-x-1'"
                class="inline-block h-4 w-4 transform rounded-full bg-white transition"
            />
        </Switch>
        <label :for="switchId" class="text-sm">{{ $t(label) }}</label>
    </div>
</template>
